<template>
  <div class="operate-dialog">
     <el-dialog
      :title="dialogTilte"
      :visible.sync="display"
      width="30%"
      center>
      <el-input v-model="roleName" placeholder="请输入新角色名称"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancel">取 消</el-button>
        <el-button type="primary" @click="confirm">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  props: {
    show: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      display: this.show
    }
  },
  mounted () {
    console.log(this.display)
  },
  watch: {
    show: function (nval) {
      this.display = nval // show改变是同步子组件display的值
    },
    display: function (nval) {
      this.$emit('update:show', nval) // display改变时同步父组件show的值
    }
  },
  methods: {
    cancel () {
      this.display = false
    },
    confirm () {
      this.display = false
    }
  }

}
</script>

<style lang='scss' scoped>

</style>
